<template>
  <v-expansion-panels v-model="panel" popout focusable>
    <v-expansion-panel
      v-for="course in filteredCourses"
      v-bind:key="course.name"
    >
      <v-expansion-panel-header>
        <v-row no-gutters>
          <v-col class="subtitle-1">
            {{ course.name }}
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-btn
          v-if="course.video != ''"
          :href="course.video"
          target="_blank"
          raised
          normal
          class="ma-1 mt-2"
        >
          Video
        </v-btn>

        <span
          v-for="prerequisite in course.prerequisites"
          v-bind:key="prerequisite.req"
        >
          <v-chip
            v-if="prerequisite.req != ''"
            outlined
            label
            color="orange darken-4"
            class="ma-1 mt-2"
          >
            <v-icon left>mdi-head-alert-outline</v-icon>
            Required: {{ prerequisite.req }}
          </v-chip>
        </span>

        <v-chip
          v-if="course.tag == 'ott'"
          outlined
          label
          color="blue darken-3"
          class="ma-1 mt-2"
        >
          <v-icon left>mdi-calendar</v-icon>
          Outside the Timetable
        </v-chip>

        <p class = "px-1 mt-1">
          <img v-if="course.name == 'SCIENCE OVERVIEW'" width="100%" src="@/assets/sciencepathways1.jpg">
          <img v-if="course.name == 'SCIENCE OVERVIEW'" width="100%" src="@/assets/sciencepathways2.jpg">
          <img v-if="course.name == 'MATH PATHWAYS OVERVIEW'" width="100%" src="@/assets/mathpathways.jpg">
          <span v-html="course.description">
          </span>
        </p>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
  import {courses} from '@/courses.js';

  export default {
    name: 'Browse',
    data: () => ({
      courses: courses,
      selectedCourse: null,
      panel: []
    }),
    props: {
      department: String,
      filteredGrade: Number
    },
    watch: {
      department: function() {
        this.panel = [];
      },
      filteredGrade: function() {
        this.panel = [];
      },
    },
    computed: {
      filteredCourses: function() {
        var department = this.department;
        var grade = this.filteredGrade;
        if (department === "All") {
          return this.courses;
        } else if (grade != null) {
          return this.courses.filter(function(course) {
            return (course.department === department && course.grades.includes(grade));
          });
        } else {
          return this.courses.filter(function(course) {
            return course.department === department;
          });
        }
      }

    }
  }
</script>
